import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../../utils/Messages';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import moment from 'moment';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { Navigate } from "react-router-dom";
import { encryptAES } from '../../../utils/Encryption';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';
import { getFinancialYearDates } from '../../../utils/DateUtils';

// autoTable(jsPDF.API);

export default class AccountHeadSummary extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.gridRef = React.createRef();
        this.state = {
            isLoading: false,
            isModalOpen: false,
            accountName: '',
            rowData: [],
            partyList: [],
            expenseByList: [
                { value: 1, label: "Party" },
                { value: 2, label: "Employee" },
                { value: 3, label: "Bank" },
                { value: 4, label: "Head" }
            ],
            colDefs: [
                {
                    // field: "docNo",
                    headerName: "Sr No",
                    valueGetter: (params) => {
                        return params.node.rowPinned ? '' : params.node.rowIndex + 1;
                    },
                    flex: 0.6,
                    minWidth: window.innerWidth * 0.04,
                    spanRows: true,
                },
                {
                    field: "transactionWith",
                    headerName: "Tran. With",
                    flex: 1.5,
                    minWidth: window.innerWidth * 0.23,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "totalAmount",
                    headerName: "Total Amount",
                    flex: 1,
                    minWidth: window.innerWidth * 0.09,
                    filter: true,
                    floatingFilter: true,

                    cellStyle: (params) => {
                        if (params?.value > 0) {
                            return { color: 'red' };   // DR
                        } else if (params?.value < 0) {
                            return { color: 'green' }; // CR
                        }
                        return null;
                    },

                    cellRenderer: (params) => {
                        const value = Number(params?.value || 0).toFixed(2);

                        if (params?.value > 0) {
                            return `${value} DR`;
                        } else if (params?.value < 0) {
                            return `${Math.abs(value).toFixed(2)} CR`;
                        }
                        return value;
                    }
                }
            ],
            openingBalance: "",
            openingBalanceType: "DR",
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            requestDetails: {
                fromDate: "",
                toDate: "",
                partyId: 0,
                exponseById: 4
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "person name"
                        ),
                    }
                ],
            },
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        let requestDetails = localStorage.getItem("accountHeadSummary");
        if (requestDetails) {
            requestDetails = JSON.parse(requestDetails);
            requestDetails.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
            requestDetails.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";
            requestDetails.isLocalStorage = true;

            let balanceDetails = {
                fromDate: requestDetails.fromDate,
                toDate: requestDetails.toDate
            }
            localStorage.setItem('balanceSheetReportDetails', JSON.stringify(balanceDetails))
            this.setState({ requestDetails: requestDetails }, () => {
                this.getAccountHeadSummary()
            });
        } else {
            let details = this.state.requestDetails
            details.fromDate = getFinancialYearDates().fromDate;
            details.toDate = getFinancialYearDates().toDate;
            this.setState({ requestDetails: details })
        }
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getSelectedExpenseByList();
            });
        }
    }

    getSelectedExpenseByList = () => {
        let request = {
            idCompany: this.state.idCompany,
            expenseById: this.state.requestDetails.exponseById,
        }
        this.accountTransactionServices.getSelectedExpenseByList(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.id,
                    label: x.name,
                    openingBalance: x.openingBalance,
                    balanceType: x.openingBlanaceType,
                }));
                this.setState({ partyList: data }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                    if (this.state.requestDetails.isLocalStorage === true) {
                        localStorage.removeItem("accountHeadSummary");
                    }
                })
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details }, () => {
            if (name === 'fromDate' || name === 'toDate') {
                if (this.state.requestDetails.partyId > 0) {
                    let opBalanceObject = this.state.partyList.find(x => x.value === this.state.requestDetails.partyId)
                    let openingBalance = opBalanceObject.openingBalance;
                    let balanceType = opBalanceObject.balanceType === "CREDIT" ? "CR" : "DR";
                    this.setState({ openingBalance: openingBalance, openingBalanceType: balanceType })
                }
            }
        });
    };

    setFilterParameters = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.value;
        if (name === "partyId") {
            let openingBalance = event.openingBalance;
            let balanceType = event.balanceType === "CREDIT" ? "CR" : "DR";
            this.setState({ openingBalance: openingBalance, openingBalanceType: balanceType, accountName: event.label });
        } else if (name === "exponseById") {
            details.partyId = 0;
        }
        this.setState({ requestDetails: details }, () => {
            if (name === "exponseById") {
                this.getSelectedExpenseByList();
            }
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }


    getAccountHeadSummary = async () => {
        let isValid = this.isValidAllFields();

        const requestCopy = {
            ...this.state.requestDetails,
            idCompany: this.state.idCompany
        };

        if (isValid) {
            try {
                const response = await this.dailyReportsServices.getAccountHeadSummary(requestCopy);
                if (response.statusCode === 200 && response.responseItem !== null) {

                    const rawData = response.responseItem.responseContent;

                    // let desired = rawData.filter(x => x.transactionWith === 'KOTAK MAHINDRA BANK - CURRENT - 9284')
                    let desired = rawData.map(x => ({
                        transactionWith: x.transactionWith,
                        idTransactionWith: x.idTransactionWith,
                        type: x.type
                    }));
                    console.log(desired)
                    const finalData = Object.values(
                        rawData.reduce((acc, item) => {
                            const key = `_${item.idTransactionWith}`;

                            if (!acc[key]) {
                                acc[key] = {
                                    ...item,
                                    totalDebit: 0,
                                    totalCredit: 0,
                                    totalAmount: 0
                                };
                            }

                            acc[key].totalDebit += Number(Number(item.debitAmount || 0).toFixed(2));
                            acc[key].totalCredit += Number(Number(item.creditAmount || 0).toFixed(2));

                            acc[key].totalAmount = Number(
                                (acc[key].totalDebit - acc[key].totalCredit).toFixed(2)
                            );

                            return acc;
                        }, {})
                    )
                    // .filter(item => item.totalAmount > 0);;

                    this.setState({ rowData: finalData, isLoading: false }, () => {
                        this.setState({ sumRow: this.calculateSumRow() });
                    });
                } else {
                    this.SwalServices.showError(response.message);
                    this.setState({ isLoading: false });
                }
            } catch (error) {
                console.error("Error fetching account head summary:", error);
                this.setState({ isLoading: false });
            }
        }
    };

    onRowDoubleClicked = (event) => {
        let requestDetails = {
            fromDate: this.state.requestDetails.fromDate,
            toDate: this.state.requestDetails.toDate,
            partyId: event.data.filterPartyId,
            exponseById: event.data.filterExponseById,
            idAccountHead: event.data.idTransactionWith,
            idTransactionWith: event.data.idTransactionWith,
            filterExponseById: event.data.exponseById,
            isFromAccountHeadSummary: true
        }
        localStorage.setItem("ledgerReportDetails", JSON.stringify(requestDetails));
        this.setState({ route: '/ledger-report' });
    };

    onExportExcel = () => {
        const { fromDate, toDate } = this.state.requestDetails;
        const { accountName } = this.state;

        if (this.gridRef.current && this.gridRef.current.api) {
            const csvData = this.gridRef.current.api.getDataAsCsv();

            const customHeader = [
                [`Account: ${accountName}`, '', '', ''].join(','),
                [`From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`, '', '', ''].join(','),
                '' // Blank line
            ].join('\r\n');

            const finalCsv = `${customHeader}\r\n${csvData}`;

            const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Ledger_Report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.warn("Grid API not ready");
        }
    };

    onExportPdf = () => {
        const doc = new jsPDF();

        const { fromDate, toDate } = this.state.requestDetails;
        const { accountName } = this.state;

        const pageWidth = doc.internal.pageSize.getWidth();

        // Header content
        const headerLines = [
            `Account: ${accountName}`,
            `From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`
        ];

        // Header styles
        const headerFontSize = 12;
        const headerTextColor = [80, 80, 80]; // white
        const headerBgColor = [245, 245, 245]; // blue
        const lineHeight = 8;
        const padding = 2;

        // Calculate total header height
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;

        // Draw background rectangle for header
        doc.setFillColor(...headerBgColor);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');

        // Set text styles
        doc.setFontSize(headerFontSize);
        doc.setTextColor(...headerTextColor);

        // Draw each header line centered
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            const x = (pageWidth - textWidth) / 2;
            const y = padding + (i + 1) * lineHeight - 2;
            doc.text(line, x, y);
        });

        // Prepare table data
        const exportableCols = this.state.colDefs.filter(col => col.headerName !== "Sr No");

        const rowData = [];
        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            rowData.push(exportableCols.map(col => node.data[col.field]));
        });

        const pinnedBottomRows = this.gridRef.current.api.getPinnedBottomRowCount();
        for (let i = 0; i < pinnedBottomRows; i++) {
            const pinnedNode = this.gridRef.current.api.getPinnedBottomRow(i);
            rowData.push(exportableCols.map(col => pinnedNode.data[col.field]));
        }

        const columnHeaders = exportableCols.map(col => col.headerName);

        // Render table below header
        autoTable(doc, {
            head: [columnHeaders],
            body: rowData,
            startY: totalHeaderHeight + 4, // leave space below header
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 140, 255], textColor: 255 },
        });

        doc.save("ledger-report.pdf");
    };

    calculateSumRow = () => {
        const { rowData } = this.state;

        const totalAmount = rowData.reduce((sum, row) => sum + Number(row.totalAmount || 0), 0);

        const grandTotal = {
            totalAmount: totalAmount,
        };

        return [grandTotal];
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='profit-loss-report'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[100%] mb-[10px]'>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-[15%]'>
                                    <label>Summary for</label>
                                    <MultiSelectDropdown
                                        className={this.state.validState?.error?.exponseById !== undefined ? "error" : ""}
                                        options={this.state.expenseByList}
                                        value={this.state.requestDetails.exponseById ? this.state.expenseByList?.find(item => item.value === this.state.requestDetails.exponseById) : 0}
                                        onChange={(event) =>
                                            this.setFilterParameters(event, "exponseById")
                                        }
                                        isDisabled={true}
                                    />
                                </div>
                                <div className='input-grp w-[45%]'>
                                    <label>Ledger of</label>
                                    <MultiSelectDropdown
                                        className={this.state.validState?.error?.partyId !== undefined ? "error" : ""}
                                        options={this.state.partyList}
                                        value={this.state.requestDetails.partyId ? this.state.partyList?.find(item => item.value === this.state.requestDetails.partyId) : 0}
                                        onChange={(event) =>
                                            this.setFilterParameters(event, "partyId")
                                        }
                                    />
                                </div>
                                <div className='input-grp w-[15%]'>
                                    <label>From date</label>
                                    <input type='date'
                                        className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        value={this.state.requestDetails.fromDate}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                    />
                                </div>
                                <div className='input-grp w-[15%]'>
                                    <label>To date</label>
                                    <input type='date'
                                        className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                        value={this.state.requestDetails.toDate}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                    />
                                </div>
                                {this.state.isLoading ?
                                    <ButtonLoader />
                                    :
                                    <button className='prm-btn h-fit !w-[10%] justify-center'
                                        onClick={() => this.getAccountHeadSummary()}
                                    >
                                        Search
                                    </button>
                                }
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 261px)" }}>
                                <div className="table-inner flex items-center justify-between mb-2.5">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Ledger report</h1>
                                    <div className='btn-grp flex items-center gap-2.5'>
                                        {/* {this.state.rowData.length > 0 ?
                                            <>
                                                <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportExcel()}>Export to Excel</button>
                                                <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportPdf()}>Export to PDF</button>
                                            </>
                                            : null} */}
                                    </div>
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    // onGridReady={this.onGridReady}
                                    pinnedBottomRowData={this.state.sumRow}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}